module.exports = __webpack_public_path__ + "static/media/agility.942e96c6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ActivityBadge/icons/agility.svg
// module id = 291
// module chunks = 0